/**
 * @generated SignedSource<<cdfd49d1c16ffa65069eeca81b569a92>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type VerticalType = "art" | "fashion" | "furniture" | "jewelry" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type CheckoutReviewStep_item$data = {
  readonly vertical: VerticalType | null;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBuyerMessage_item" | "CheckoutGifting_item" | "CheckoutReturningBuyerDeliveryOptionsView_item" | "CheckoutReviewStepDeliveryView_item" | "CheckoutReviewTally_item" | "CheckoutSidebarPromotion_item" | "CheckoutStickySubmitButton_item" | "CheckoutSubmitButton_item" | "useCustomsMessagingQuery_item">;
  readonly " $fragmentType": "CheckoutReviewStep_item";
};
export type CheckoutReviewStep_item$key = {
  readonly " $data"?: CheckoutReviewStep_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutReviewStep_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutReviewStep_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSubmitButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutBuyerMessage_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutReviewStepDeliveryView_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutGifting_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutReturningBuyerDeliveryOptionsView_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutStickySubmitButton_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useCustomsMessagingQuery_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutSidebarPromotion_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutReviewTally_item"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vertical",
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "237918dfccbe9233348bd18fac0760ef";

export default node;
